import {
  InfoBox,
  InputCheckboxField,
  InputField,
  InputLabel,
  InputSelectField,
  InputWrapper,
  Section,
} from '@presentation/components';
import { allPhonePrefixSelectOptions, useRouter } from '@application/utils';
import type { FC } from 'react';
import * as Styled from '../../styled';
import type { WhatsappFormProps } from './types';

export const WhatsappForm: FC<WhatsappFormProps> = (props) => {
  const { breeder } = props;
  const { translate, routeLocationDescriptor } = useRouter();

  const phonePrefixes = allPhonePrefixSelectOptions(translate);

  return (
    <Section>
      <InputWrapper>
        <Styled.InputWrapper>
          <InputLabel required>{translate('common.inputs.firstName.label')}</InputLabel>
          <InputField name="firstName" />
        </Styled.InputWrapper>
        <Styled.InputWrapper>
          <InputLabel required>{translate('common.inputs.lastName.label')}</InputLabel>
          <InputField name="lastName" />
        </Styled.InputWrapper>
        <Styled.InputWrapper>
          <InputLabel required>{translate('common.inputs.email.label')}</InputLabel>
          <InputField name="email" type="email" />
        </Styled.InputWrapper>
        <InputWrapper>
          <InputLabel required>{translate('common.inputs.phone.label')}</InputLabel>
          <InputWrapper inline width="39%" fullWidthBreakpoint="min" noMargin>
            <InputSelectField name="phonePrefixCountry" options={phonePrefixes} />
          </InputWrapper>
          <InputWrapper inline width="61%" fullWidthBreakpoint="min" last noMargin>
            <InputField name="phone" type="tel" />
          </InputWrapper>
        </InputWrapper>
        <Styled.InputWrapper>
          <InputLabel required>{translate('common.modals.whatsApp.input')}</InputLabel>
          {breeder?.spokenLanguages ? (
            <InfoBox>
              {translate('common.inputs.motive.infos').replace(
                '$spokenLanguages',
                breeder.spokenLanguages,
              )}
            </InfoBox>
          ) : null}
          <InputField name="message" textarea />
        </Styled.InputWrapper>
      </InputWrapper>
      <InputWrapper>
        <InputCheckboxField name="marketingEmailConsent">
          <Styled.TermsContainer
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: translate('common.inputs.termsPolicyEmailMarketing.label').replace(
                '$link',
                routeLocationDescriptor('privacy').pathname ?? '',
              ),
            }}
          />
        </InputCheckboxField>
      </InputWrapper>
    </Section>
  );
};
